import { useState } from 'react';
import { EpisodeAsset } from '../../../queries/ats/titles/types/asset';

export function useActiveSeason(seasons: number[], focusedAsset: EpisodeAsset) {
  const [activeSeason, setActiveSeason] = useState(focusedAsset.season.sequenceNumber);

  if (!seasons.includes(activeSeason)) {
    return [focusedAsset.season.sequenceNumber, setActiveSeason] as const;
  }

  return [activeSeason, setActiveSeason] as const;
}
